export class JobPositionMatch {
    jobCategoryId: number;
    jobCategoryName: string;
    jobPositionId: number;
    jobPositionName: string;
    isMatched: boolean;
}
